import { UtilityService } from '@eforall/common';
import { GridSetup } from '@eforall/dashboard';
import { VolunteerSignupSpecialistTopic } from '@interfaces';
import { SpecialistSignUpViewerDialogDataService } from '../../specialist-sign-up-viewer-dialog-data.service';
import { getActions } from './get-actions';
import { getColumns } from './get-columns';


export function getSetup(service: SpecialistSignUpViewerDialogDataService, util: UtilityService): GridSetup<VolunteerSignupSpecialistTopic> {
	return {
		rowName: { singular: 'Sign Ups Specialist Topic', plural: 'Sign Ups Specialists	Topics' },
		getRowKey: row => '' + row.volunteerSignupSpecialistTopicId,
		stateKey: 'specialist-sign-up-topic-grid',
		actions: getActions(),
		buttons: [],
		columns: getColumns(util),
	}
}
